{
  "title": "My profile",
  "subtitle": "Manage your display name, phone number, and password",
  "backToAdmin": "Back to admin",
  "backToManage": "Back to manage",
  "backToClient": "Back to portal",
  "backToHome": "Back to home",
  "accountInfo": "Account information",
  "editName": "Display name",
  "namePlaceholder": "Your name",
  "nameHint": "This name is shown across the app.",
  "saveName": "Save name",
  "nameUpdated": "Name updated successfully",
  "nameUpdateFailed": "Failed to update name",
  "fields": {
    "email": "Email",
    "name": "Name",
    "role": "Role",
    "phone": "Phone",
    "emailVerified": "Email verified",
    "phoneVerified": "Phone verified",
    "memberSince": "Member since"
  },
  "verified": "Verified",
  "notVerified": "Not verified",
  "emailVerifiedTag": "Email verified",
  "emailNotVerifiedTag": "Email not verified",
  "phoneVerified": "Phone verified",
  "phoneNotVerified": "Phone not verified",
  "phoneSection": "Phone number",
  "changePhone": "Change phone number",
  "addPhone": "Add phone number",
  "phoneEmptyDescription": "Add a phone number to enable SMS login after verification.",
  "phoneVerifiedHint": "This number is verified and can be used to sign in with SMS.",
  "phoneUnverifiedHint": "Verify this number with an SMS code before you can use SMS login.",
  "changePhoneHint": "Enter a new number, then confirm it with the SMS code we send.",
  "copyPhone": "Copy number",
  "phoneCopied": "Copied",
  "sendCode": "Send verification code",
  "resendCode": "Resend code",
  "verifyPhone": "Verify phone number",
  "codeLabel": "Verification code",
  "codeRequired": "Enter the 6-digit code",
  "codeSent": "Verification code sent",
  "codeSendFailed": "Failed to send verification code",
  "codeVerifyFailed": "Failed to verify phone number",
  "phoneVerifiedSuccess": "Phone number verified successfully",
  "phoneRequired": "Phone number is required",
  "phoneInvalid": "Please enter a complete, valid phone number",
  "phoneAlreadyUsed": "This phone number is already associated with another account",
  "phoneAlreadyVerified": "This phone number is already verified",
  "invalidCode": "Invalid verification code",
  "codeExpired": "Verification code expired. Please request a new one",
  "phoneManageUnavailable": "Phone verification is not available for your account role.",
  "notSet": "Not set",
  "emailSection": "Email",
  "addEmail": "Add email",
  "changeEmail": "Change email",
  "emailEmptyDescription": "Add an email address to enable email login after verification.",
  "emailVerifiedHint": "This email is verified and can be used to sign in with a password.",
  "emailUnverifiedHint": "Open the verification link we sent, or resend it if you did not get the email.",
  "changeEmailHint": "Enter a new address. We will send a verification link before it becomes active.",
  "emailPlaceholder": "you@example.com",
  "emailRequired": "Email is required",
  "emailInvalid": "Please enter a valid email address",
  "sendEmailVerification": "Send verification email",
  "resendEmail": "Resend verification email",
  "emailVerificationSent": "Verification email sent",
  "emailSendFailed": "Failed to send verification email",
  "emailAlreadyUsed": "This email is already associated with another account",
  "emailAlreadyVerified": "This email is already verified",
  "emailVerifiedReadOnly": "A verified email cannot be changed here",
  "security": "Security",
  "changePassword": "Change password",
  "currentPassword": "Current password",
  "currentPasswordRequired": "Current password is required",
  "currentPasswordPlaceholder": "Enter your current password",
  "newPassword": "New password",
  "confirmPassword": "Confirm new password",
  "confirmPasswordRequired": "Please confirm your new password",
  "updatePassword": "Update password",
  "passwordUpdated": "Password updated successfully",
  "passwordUpdateFailed": "Failed to update password",
  "passwordCreated": "Password created successfully",
  "createPassword": "Create password",
  "createPasswordHint": "Create a password so you can also sign in with email.",
  "passwordHint": "Enter your current password to set a new one.",
  "fixFormErrors": "Please fix the highlighted fields and try again.",
  "errors": {
    "currentPasswordIncorrect": "The current password you entered is incorrect. Please try again.",
    "passwordCannotBeChanged": "Your password is managed by your sign-in provider and cannot be changed here.",
    "passwordAlreadySet": "A password is already set. Use change password instead.",
    "authenticationRequired": "Your session has expired. Please sign in again.",
    "forbidden": "You do not have permission to perform this action.",
    "serverError": "Something went wrong on our end. Please try again in a moment.",
    "loadFailed": "Could not load your profile. Please refresh the page.",
    "networkError": "Could not reach the server. Check your connection and try again."
  }
}
